<template>
  <div class="tw-container tw-pb-48 tw-px-8 xl:tw-px-24 tw-mx-auto">
    <div class="tw-mb-16">
      <RouterLink to="/menu" class="tw-uppercase tw-text-lg lg:tw-text-2xl tw-font-bold tw-px-2 hover:tw-text-orange-medium">Menu</RouterLink> >
      <RouterLink 
        :to="{ name: 'review-bag'}"
        class="tw-uppercase tw-text-lg lg:tw-text-2xl tw-font-bold tw-px-2 hover:tw-text-orange-medium">
          Your Bag
      </RouterLink> >
      <span class="tw-uppercase tw-text-lg lg:tw-text-2xl tw-font-bold tw-px-2">Checkout</span>
    </div>

    <template v-if="userStore.userLocation && userStore.userLocation.id">
      <LocationAlerts
        class="tw-mb-12"
       :location="(userStore.userLocation! as any) as Location" />
    </template>

    <h2 class="tw-text-6xl tw-font-bold tw-mb-12 lg:tw-mb-16">Checkout</h2>
    <div class="lg:tw-flex" v-if="basketStore.basket">
      <div class="tw-w-full lg:tw-mx-auto lg:tw-w-2/3">

          <EditOrderAlert
            v-if="showEditingOrderAlert"
            :cutoffTime="editCutoffTime"
            @cancelEditOrder="cancelEditOrder"
          />

          <div class="tw-mb-24 lg:tw-mr-96" v-if="state.userPrompt != null">
            <a class="tw-block tw-mb-16" href="/order/users/login?n=online-catering-checkout" v-if="state.userPrompt == 'login'">
              <div id="login_register_invitation">
                <div class="row">
                  <div class="col-md-3">
                    <span class="piada-one po50"></span>
                  </div>
                  <div class="col-md-9">
                    Sign in or create an account to earn a <u><strong>FREE Piada Stick</strong></u> now by joining our Piada One rewards program.
                  </div>
                </div>
              </div>
            </a>

          <h2 class="tw-text-5xl tw-mb-8">Contact Information</h2>
          <ContactInfoForm 
            :firstName="state.contactInfo.firstName"
            :lastName="state.contactInfo.lastName"
            :emailAddress="state.contactInfo.emailAddress"
            :phoneNumber="state.contactInfo.phoneNumber"
            :contact="state.contactInfo.contact"
            :disabled="userStore.user != null"
            :deliverymode="cateringOrderStore.cateringOrder!.delivery_mode"
            @setFirstName="firstNameSet"
            @setLastName="lastNameSet"
            @setEmailAddress="emailAddressSet"
            @setPhoneNumber="phoneNumberSet"
            @setContact="contactSet"
          />
        </div>
        <div class="tw-mb-16 lg:tw-mr-32" v-if="cateringOrderStore.cateringOrder && cateringOrderStore.cateringOrder.delivery_mode == 'delivery'">
          <DeliveryForm
            :streetaddress="state.deliveryInfo.streetaddress"
            :building="state.deliveryInfo.building"
            :city="state.deliveryInfo.city"
            :zipcode="state.deliveryInfo.zipcode"
            :specialinstructions="state.deliveryInfo.specialinstructions"
            :disabled="false"
            :submittingDeliveryInfo="state.deliveryInfo.submitting"
            @setStreetaddress="streetaddressSet"
            @setBuilding="buildingSet"
            @setCity="citySet"
            @setZipcode="zipcodeSet"
            @setSpecialinstructions="specialinstructionsSet" 
            @submitDeliveryInfo="deliveryInfoSubmit" />

          <template v-if="basketStore.basket.deliverymode && basketStore.basket.deliverymode == 'dispatch'">
            <DeliveryTip
              :basket="basketStore.basket" 
              :settingTip="state.settingTip"
              @emitTip="setTip"
              />
          </template>
        </div>

        <h2 class="tw-text-5xl tw-mb-12">Payment Method</h2>
        
        <div class="tw-mb-16">
          <PaymentMethodForm 
            :billingAccounts="state.billingAccounts"
            :selectedPayment="state.selectedPayment"
            :user="userStore.user != null"
            :billingSchemes="state.billingSchemes"
            :deliverymode="cateringOrderStore.cateringOrder!.delivery_mode"
            @setBillingAccount="billingAccountSet"
            @setNewCreditCard="newCreditCardSet"
            @setNewGiftCard="newGiftCardSet"
            @setRefuel="refuelSet"
            @resetPaymentMethod="paymentMethodReset"
          />
        </div>
      </div>

      <div class="tw-flex-shrink-0 tw-w-full lg:tw-w-156">
        <div class="tw-rounded-3xl tw-overflow-hidden tw-shadow-lg tw-bg-white tw-mb-16">
          <OrderDetails />

          <div class="tw-border-t tw-border-black tw-py-8 tw-px-8">
            <div class="tw-mb-10 ">
              <label for="promo_code" class="tw-uppercase tw-pointer-events-none tw-py-4 tw--z-1 tw-duration-300 tw-origin-top-left">Promo Code</label>
              <div class="">
                <input 
                  v-model="state.promoCode"
                  type="text" 
                  @keyup.enter="promocodeKeyup"
                  name="promo_code" 
                  placeholder="Enter promo code"
                  class="tw-block tw-w-full tw-text-2xl tw-py-4 tw-border tw-border-black tw-appearance-none focus:tw-outline-0 tw-bg-transparent focus:tw-ring-0 focus:tw-border-orange-medium focus:tw-ring-orange-medium tw-pl-4 tw-pr-32 tw-rounded-full tw-mb-4" /> 

                  <TwButton 
                    cssClass="tw-block tw-w-full tw-bg-orange-medium hover:tw-bg-orange-dark tw-border-orange-medium tw-border-2 tw-rounded-full tw-text-white tw-uppercase tw-font-bold tw-px-8 tw-py-4 tw-transition-all tw-duration-200 tw-uppercase" 
                    @emit-click="promoAction" 
                    :isLoading="state.submittingPromo"
                    :isDisabled="false" 
                    buttonText="apply code"/>
              </div>
            </div>
          </div>
          <div class="tw-border-t tw-border-black tw-py-8 tw-px-8" v-if="basketStore.basket && basketStore.basket.products && basketStore.basket.products.length > 0">
            <div class="tw-mb-10" v-if="userStore.user">
              <label for="rewards" class="tw-uppercase tw-pointer-events-none tw-py-4 tw--z-1 tw-duration-300 tw-origin-top-left">Piada Rewards</label>
              <TwButton 
                cssClass="tw-block tw-w-full tw-bg-orange-medium hover:tw-bg-orange-dark hover:tw-text-white tw-border-orange-medium tw-border-2 tw-rounded-full tw-text-white tw-uppercase tw-font-bold tw-px-8 tw-py-4 tw-transition-all tw-duration-200 tw-uppercase"
                @emit-click="rewardsButtonClick" 
                :isLoading="state.applyingRewards"
                :isDisabled="state.rewardsLoading" 
                :buttonText="rewardsButtonText"/>
            </div>
          </div>

          <div class="tw-border-t tw-border-black tw-pt-8 tw-px-8">
            <BagTotals 
              @emit-removeDiscount="removeDiscount" />
          </div>
          
          <div class="tw-text-center tw-mt-16">
            <div class="tw-mb-8 tw-px-8 tw-text-xl tw-text-black">
              Catering orders that are canceled with less than a three-hour notice will be charged a cancelation fee of 50% of the order total.
            </div>

            <TwButton 
              cssClass="tw-block tw-w-full tw-bg-orange-medium tw-text-white hover:tw-bg-orange-dark hover:tw-text-white tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200"
              @emit-click="submitOrderClicked" 
              :isLoading="state.submittingOrder"
              :isDisabled="state.settingTip || state.submittingPromo || state.applyingRewards" 
              :buttonText="checkoutText"/>
          </div>
        </div>

        <TwCateringHelp />

      </div>
    </div>

    <TwModal
      v-show="state.showRewardsModal == true"
      :hasAccept="true"
      :hasHeader="false"
      :modalSize="'large'"
    >
      <template v-slot:body>
        <div class="tw-sticky md:tw-static tw-top-0 tw-z-40 tw-bg-white tw-w-full tw-pl-6 tw-pr-6 md:tw-pr-24 tw-pt-6 md:tw-pt-0 tw-pb-4 md:tw-pb-4 rewards-modal__header">
          <div class="tw-flex tw-items-center tw-justify-between tw-gap-3">
            <h2 class="tw-font-black tw-text-4xl md:tw-text-5xl tw-mb-0">Available Rewards</h2>
            <div class="tw-flex tw-items-center tw-gap-2">
              <button
                type="button"
                class="tw-text-4xl md:tw-text-5xl tw-leading-none tw-transition-all tw-duration-300 hover:tw-text-orange-medium"
                @click="closeRewardsModal"
                aria-label="Close"
              >
                &times;
              </button>
            </div>
          </div>
        </div>

        <div class="tw-flex tw-flex-nowrap tw-overflow-x-auto tw-gap-8 tw-mb-12 tw-items-stretch tw-pl-6 tw-pr-6 md:tw-pl-0 md:tw-pr-0 md:tw-flex-wrap md:tw-overflow-visible md:tw-justify-center" v-if="state.rewards != null && state.rewards.length > 0">
          <ReviewCard 
            :class="['tw-flex-none tw-min-w-[18rem] md:tw-flex-1 md:tw-basis-1/3 md:tw-max-w-15/32 md:tw-min-w-0']"
            :reward="reward" 
            :selected="basketStore.basket?.hasRewardApplied(reward.credential_identifier)"
            :isLoading="!state.showRewardsDiscountModal && state.applyingRewards"
            @applyReward="applyRewardClicked"
            @removeReward="removeReward"
            v-index="reward.credential_identifier" 
            v-for="reward in state.rewards"/>
        </div>
        
      </template>

      <template v-slot:footer>
        <div class="tw-hidden md:tw-flex md:tw-justify-center md:tw-items-center tw-px-8 tw-pt-16 tw-pb-8">
          <TwButton 
            cssClass="tw-bg-orange-medium tw-border-2 tw-border-orange-medium tw-text-white hover:tw-bg-black hover:tw-border-black tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200 tw-ml-8 tw-rounded-full"
            @emit-click="closeRewardsModal" 
            :isLoading="false"
            :isDisabled="false" 
            :buttonText="'Close'"/>
        
        </div>
      </template>
    </TwModal>

    <TwModal
      v-show="state.showRewardsDiscountModal == true || state.showPromoDiscountModal == true"
      :hasAccept="true"
      :hasHeader="false"
    >
      <template v-slot:body>
        <div class="tw-relative tw-pr-24 tw-w-full">
          <h2 class="tw-font-black tw-text-5xl tw-mb-10">Available Rewards</h2>
          <button
            type="button"
            class="tw-text-5xl tw-absolute tw-right-2 tw-top-0 hover:tw-text-orange-medium tw-transition-all tw-duration-300"
            @click="closeRewardsDiscountModal"
          >
            &times;
          </button>
        </div>
      </template>

      <template v-slot:footer>
        <div class="tw-flex tw-justify-center tw-items-center tw-px-8 tw-pt-16 tw-pb-8">
          <TwButton 
            cssClass="tw-bg-transparent tw-border-2 tw-border-orange-medium tw-text-orange-medium hover:tw-text-black hover:tw-border-black tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200 tw-ml-8 tw-rounded-full"
            @emit-click="closeRewardsDiscountModal" 
            :isLoading="false"
            :isDisabled="false" 
            :buttonText="'Cancel'"/>

            <template v-if="state.selectedReward && state.showRewardsDiscountModal">
              <TwButton 
              cssClass="tw-bg-orange-medium tw-border-2 tw-border-orange-medium tw-text-white hover:tw-bg-black hover:tw-border-black tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200 tw-ml-8 tw-rounded-full"
              @emit-click="applyReward(state.selectedReward)" 
              :isLoading="state.applyingRewards"
              :isDisabled="false" 
              :buttonText="'Yes'"/>
            </template>

            <template v-if="state.showPromoDiscountModal">
              <TwButton 
                cssClass="tw-bg-orange-medium tw-border-2 tw-border-orange-medium tw-text-white hover:tw-bg-black hover:tw-border-black tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200 tw-ml-8 tw-rounded-full"
                @emit-click="submitPromo()" 
                :isLoading="state.submittingPromo"
                :isDisabled="false" 
                :buttonText="'Yes'"/>
            </template>
        
        </div>
      </template>
    </TwModal>

    <TwModal
      v-show="cateringOrderStore.preAdjustmentTime != null"
      :hasAccept="true"
      :hasHeader="false"
      @emitClose="closeTimeAdjustment"
    >
      <template v-slot:body>
        <p class="tw-mb-16 tw-text-center tw-text-3xl">Your order could not be ready by the requested time.<br/>It has been updated to the next available time slot. </p>
       
        <div class="tw-text-center tw-px-4 tw-font-black tw-text-6xl" v-if="currentBasketTimeWanted">
          {{currentBasketTimeWanted.toFormat('M/dd h:mm a')}}
        </div>
      </template>

      <template v-slot:footer>
        <div class="tw-flex tw-justify-center tw-items-center tw-px-8 tw-pt-16 tw-pb-8">
          <TwButton 
            cssClass="tw-border-2 tw-border-gray-400 tw-text-gray-400 hover:tw-bg-orange-medium hover:tw-border-orange-medium hover:tw-text-white tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200 tw-mr-8 tw-rounded-full"
            @emit-click="pickTimeAdjustment" 
            :isLoading="false"
            :isDisabled="false" 
            :buttonText="'Pick Another'"/>
          <TwButton 
            cssClass="tw-bg-orange-medium tw-border-2 tw-border-orange-medium tw-text-white hover:tw-bg-black hover:tw-border-black tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200 tw-ml-8 tw-rounded-full"
            @emit-click="closeTimeAdjustment" 
            :isLoading="false"
            :isDisabled="false" 
            :buttonText="'Confirm Time'"/>
        
        </div>
      </template>
    </TwModal>

    <TwModal
      v-show="state.cateringDisabledModalOpen"
      :hasAccept="true"
      :hasHeader="false"
      @emitClose="closeCateringDisabledModal"
      >
      <template v-slot:body>
        <div class="tw-relative tw-pr-24 tw-w-full">
          <h2 class="tw-mx-8 tw-font-black tw-text-5xl tw-mb-6 lg:tw-my-8">Online catering unavailable at {{ state.cateringDisabledModalLocation ? state.cateringDisabledModalLocation.name : 'this location' }}</h2>
        </div>

        <p class="tw-mx-8 tw-mb-8 tw-text-3xl !tw-leading-relaxed">
         {{ state.cateringDisabledMessage }}
        </p>
      </template>

      <template v-slot:footer>
        <div class="tw-flex tw-justify-center tw-items-center tw-px-8 tw-pt-16 tw-pb-8">
          <TwButton 
            cssClass="tw-bg-orange-medium tw-border-2 tw-border-orange-medium tw-text-white hover:tw-bg-black hover:tw-border-black tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200 tw-ml-8 tw-rounded-full tw-inline-block"
            @emit-click="redirectWizard" 
            :isLoading="false"
            :isDisabled="false" 
            :buttonText="'Start New Order'"/>
          </div>
      </template>
    </TwModal>
  </div>
</template>

<script setup lang="ts">
  import {
    reactive, computed, onMounted, ref, watch, getCurrentInstance,
    onBeforeMount
  } from 'vue';
  import { useRouter } from 'vue-router';

  // Data
  import { useBasketStore } from '../../stores/basket';
  import { useCateringOrderStore } from "../../stores/catering_order";
  import { useMenuStore } from '../../stores/menu';
  import { useUserStore } from '../../stores/user';
  import { useFlashMessageStore } from '../../stores/flashMessages';

  import { plainToClass } from 'class-transformer';
  import { purchase, event } from 'vue-gtag';

  import type BillingAccount from '../../classes/BillingAccount';
  import BasketBillingMethod from '../../classes/BasketBillingMethod';
  import type CreditCard from '../../classes/CreditCard';
  import type GiftCard from '../../classes/GiftCard';
  import type Reward from '../../types/Reward'
  import type FlashMessage from '../../types/FlashMessage'
  import Order from '../../classes/Order';
  import type Location from '../../classes/Location';
  import type RewardInterface from '../../types/Reward';
  import type RewardsProgram from '../../classes/RewardsProgram';
  import type Discount from '@/types/Discount';
  import type OrderDetailsClass from '../../classes/OrderDetails';
  import type BillingScheme from '../../types/BillingScheme';
  import { DateTime } from "luxon";

  // Components
  import OrderDetails from '../bag/_OrderDetails.vue';
  import Bag from '../bag/_Bag.vue';
  import BagTotals from '../bag/_BagTotals.vue';
  import ReviewCard from './_RewardCard.vue';
  import TwModal from '../../components/TwModal.vue';
  import ContactInfoForm from './_ContactInfoForm.vue';
  import DeliveryForm from './_DeliveryForm.vue';
  import DeliveryTip from './_DeliveryTip.vue';
  import PaymentMethodForm from './_PaymentMethodForm.vue';
  import LocationAlerts from '../../components/LocationAlerts.vue';

  import TwButton from '../../components/TwButton.vue';
  import TwCateringHelp from '../../components/TwCateringHelp.vue';
  import EditOrderAlert from '../../components/EditOrderAlert.vue';

  const basketStore = useBasketStore();
  const cateringOrderStore = useCateringOrderStore();
  const menuStore = useMenuStore();
  const userStore = useUserStore();
  const flashMessageStore = useFlashMessageStore();

  const router = useRouter(); 

  const app = getCurrentInstance();

  const state = reactive({
    userPrompt: null as (string | null),
    contactInfo: {
      firstName: '',
      lastName: '',
      emailAddress: '',
      phoneNumber: '',
      contact: '',
    },
    deliveryInfo: {
      streetaddress: '',
      building: '',
      city: '',
      zipcode: '',
      specialinstructions: '',
      dirty: false,
      submitting: false,
    },
    promoCode: '',
    submittingPromo: false,
    applyingRewards: false,
    availableRewards: undefined as (undefined | RewardInterface[]),
    rewardsLoading: true,
    submittingOrder: false,
    settingTip: false,
    billingSchemes: [] as BillingScheme[],
    billingAccounts: [] as BillingAccount[],
    selectedPayment: undefined as (BasketBillingMethod | undefined),
    rewards: [] as Reward[],
    showRewardsModal: false,
    showRewardsDiscountModal: false,
    showPromoDiscountModal: false,
    selectedReward: undefined as (undefined | RewardInterface),
    cateringDisabledModalOpen: false,
    cateringDisabledModalLocation: undefined as (undefined | Location),
    cateringDisabledMessage: "" as (string | undefined),
  })

  onMounted(() => {
    const basket = basketStore.basket;

    if (cateringOrderStore.cateringOrder && cateringOrderStore.cateringOrder.time_wanted == null) {
      // The user has not yet set a time wanted so go force one
      errorFlash("Select a Time", "You must select a time for your order to be ready.")
      router.push('/wizard/4');
    // Preset timewanted
    } else {
      if (basket && cateringOrderStore.cateringOrder) {

        basketStore.getBillingSchemes().then((schemes: BillingScheme[]) => {
          state.billingSchemes = schemes;
        });
      
        if (userStore.user) {
          const user = userStore.user;

          // Set the contact info to the current user
          state.contactInfo.firstName = user.first_name;
          state.contactInfo.lastName = user.last_name;
          state.contactInfo.emailAddress = user.email;
          state.contactInfo.phoneNumber = user.contact_number;

          // Fetch saved user payment methods if the user exists
          userStore.fetchBillingAccounts().then((accts) => {
            state.billingAccounts = accts;
          })

          initializeRewards();
        
          state.userPrompt = 'user';
        } else {
          state.userPrompt = 'login';
        }

        // User has already set a delivery address so prefill our state
        if (basket && basket!.deliveryaddress && basket!.deliveryaddress.id) {
          state.deliveryInfo.streetaddress = basket!.deliveryaddress.streetaddress;
          state.deliveryInfo.building = basket!.deliveryaddress.building;
          state.deliveryInfo.city = basket!.deliveryaddress.city;
          state.deliveryInfo.zipcode = basket!.deliveryaddress.zipcode;
          state.deliveryInfo.specialinstructions = basket!.deliveryaddress.specialinstructions;
        }

        if (cateringOrderStore.cateringOrder!.contact_name) {
          state.contactInfo.contact = cateringOrderStore.cateringOrder!.contact_name;
        }
      } else {
        router.push('wizard'); // User doesn't have a location set so force them to pick one;
      }
    }
  })

  const initializeRewards = () => {
    if (userStore.user) {
      userStore.fetchRewards().then((rewards: RewardInterface[]) => {
        if (rewards) {
          state.rewards = rewards;
          state.rewardsLoading = false;
        }
      })
    }
  }

  watch(() => basketStore.basket, (basketUpdatedState, previousBasketState) => { 
    if (basketUpdatedState && basketUpdatedState.deliveryaddress && basketUpdatedState.deliveryaddress.streetaddress != state.deliveryInfo.streetaddress) {
      state.deliveryInfo.streetaddress = basketUpdatedState!.deliveryaddress.streetaddress;
      state.deliveryInfo.building = basketUpdatedState!.deliveryaddress.building;
      state.deliveryInfo.city = basketUpdatedState!.deliveryaddress.city;
      state.deliveryInfo.zipcode = basketUpdatedState!.deliveryaddress.zipcode;
      state.deliveryInfo.specialinstructions = basketUpdatedState!.deliveryaddress.specialinstructions;
    }

    if (basketStore.basket && basketStore.basket.id) {
      basketStore.getBillingSchemes().then((schemes: BillingScheme[]) => {
        state.billingSchemes = schemes;
      });
    }
  })

  const currentBasketTimeWanted = computed(() => {
    if (basketStore.basket) {
      let dt = DateTime.fromFormat(basketStore.basket!.timewanted, 'yyyyMMdd hh:mm')
      return dt;
    } else {
      return null;
    }
  })

  const checkoutText = computed(() => {
    let str = 'PLACE ORDER'

    if (basketStore.basket && basketStore.basket!.total) {
      str += ' — $'
      str += basketStore.basket!.total.toLocaleString("en-US", {minimumFractionDigits: 2});
    }

    return str;
  })

  const promocodeKeyup = ((event: Event) => {
    if (state.promoCode && state.promoCode.length > 0) {
      submitPromo();
    }
  })
  
  const promoAction = (() => {
    if (state.promoCode && state.promoCode.length > 0) {
      submitPromo();
    }
  })


  const removeDiscount = ((discount: Discount) => {
    state.submittingPromo = true;

    if ((discount as Discount) != null) {
      if ((discount as Discount).discounttype == 'reward') {
        removeRewardDiscount(discount.couponcode);
      } else {
        removePromo(discount.couponcode);
      }
    }
  })


  const promptForMultipleDiscounts = (() => {
    state.showPromoDiscountModal = true;
  })

//---------------------------------------------------------------
//
// Setters for state from children
//
//---------------------------------------------------------------

  const firstNameSet = ((val: string) => {
    state.contactInfo.firstName = val;
  })

  const lastNameSet = ((val: string) => {
    state.contactInfo.lastName = val;
  })

  const emailAddressSet = ((val: string) => {
    state.contactInfo.emailAddress = val;
  })

  const phoneNumberSet = ((val: string) => {
    state.contactInfo.phoneNumber = val;
  })

  const contactSet = ((val: string) => {
    state.contactInfo.contact = val;
  })

  const streetaddressSet = ((val: string) => {
    state.deliveryInfo.dirty = true;
    state.deliveryInfo.streetaddress = val;
  })

  const buildingSet = ((val: string) => {
    state.deliveryInfo.dirty = true;
    state.deliveryInfo.building = val;
  })

  const citySet = ((val: string) => {
    state.deliveryInfo.dirty = true;
    state.deliveryInfo.city = val;
  })

  const zipcodeSet = ((val: string) => {
    state.deliveryInfo.dirty = true;
    state.deliveryInfo.zipcode = val;
  })

  const specialinstructionsSet = ((val: string) => {
    state.deliveryInfo.dirty = true;
    state.deliveryInfo.specialinstructions = val;
  })

  const billingAccountSet = ((val: BillingAccount) => {
    var bbm = val.toBasketBillingMethod()
    bbm.amount = basketStore.basket!.total

    state.selectedPayment = bbm;
  })

  const newCreditCardSet = ((val: CreditCard) => {
    const bbm = val.toBasketBillingMethod()

    state.selectedPayment = bbm
  })

  const newGiftCardSet = ((val: GiftCard) => {
    const giftCardBillingScheme = state.billingSchemes.find((scheme: BillingScheme) => {
      return scheme.type == "giftcard"
    })

    const bbm = val.toBasketBillingMethod(giftCardBillingScheme!.id!)

    state.selectedPayment = bbm
  })

  const refuelSet = (() => {
    let bbm = plainToClass(BasketBillingMethod, {
      billingmethod: 'refuel',
    }, { excludeExtraneousValues: true });

    state.selectedPayment = bbm;
  })

  const paymentMethodReset = (() => {
    state.selectedPayment = undefined;
  })

//---------------------------------------------------------------
//
// Checkout methods
//
//---------------------------------------------------------------

  const setTip = ((tip: number) => {
    state.settingTip = true;

    basketStore.setTip(tip).then(() => {
      state.settingTip = false;
    }).catch((error: Error) => {
      state.settingTip = false;
      errorFlash("Error Setting Tip", error.message);
    })
  })

  const submitPromo = (() => {
    if (state.promoCode && state.promoCode.length > 0) {
      state.submittingPromo = true;
      basketStore.applyPromo(state.promoCode).then(() =>{
        state.submittingPromo = false;       
        state.showPromoDiscountModal = false;
        state.promoCode = '';
      }).catch((error) => {
        state.showPromoDiscountModal = false;
        if (error.message && error.message == "timeNeedsAdjusted") { 
          state.promoCode = "";
          const currentTimeWanted = DateTime.fromISO(cateringOrderStore.cateringOrder!.time_wanted)
          // The basket already had a time set on it; so we'll have to notify the user
          setNextAvailableTimeFallback(true, currentTimeWanted).then(() => {
            state.submittingPromo = false;
          });
        } else {
          state.submittingPromo = false;
          errorFlash("Promo Code Error", error.message);
        }
      })
    } else {
      errorFlash("Promo Code", "Please enter a valid promo code.")
    }
  })

  const removePromo = ((couponcode: string) => {
    state.submittingPromo = true;
    state.promoCode = '';
    basketStore.removePromo(couponcode).then(() =>{
      state.submittingPromo = false;
    }).catch((error: Error) => {
      if (error.message && error.message == "timeNeedsAdjusted") { 
        const currentTimeWanted = DateTime.fromISO(cateringOrderStore.cateringOrder!.time_wanted)
        // The basket already had a time set on it; so we'll have to notify the user
        setNextAvailableTimeFallback(true, currentTimeWanted).then(() => {
          state.submittingPromo = false;
        });
      } else {
        state.submittingPromo = false;
        errorFlash("Error", error.message);
      }
    })
  })

  const applyRewardClicked = ((reward: RewardInterface) => {
    state.selectedReward = reward;
    let basket = basketStore.basket;

    // if (basket != null && basket.hasCouponsApplied()) {
    //     state.showRewardsDiscountModal = true;
    // } else {
      applyReward(reward);
    // }
  })

  const applyReward = ((reward: RewardInterface) => {
    state.applyingRewards = true;

    basketStore.applyReward(reward.credential_identifier).then(() => {
      state.applyingRewards = false;
      state.showRewardsModal = false;
      state.showRewardsDiscountModal = false;
    }).catch((error: Error) => {
      if (error.message && error.message == "timeNeedsAdjusted") { 
        const currentTimeWanted = DateTime.fromISO(cateringOrderStore.cateringOrder!.time_wanted)
        // The basket already had a time set on it; so we'll have to notify the user
        setNextAvailableTimeFallback(true, currentTimeWanted).then(() => {
          state.applyingRewards = false;
          state.showRewardsModal = false;
          state.showRewardsDiscountModal = false;
        });
      } else {
        state.applyingRewards = false;
        state.showRewardsModal = false;
        state.showRewardsDiscountModal = false;
        errorFlash("Error", error.message);
      }
    })
  })

  // Using a separate method to remove a reward by its discount instead of from the full reward object
  const removeRewardDiscount = ((rewardcode: string) => {
    state.applyingRewards = true;
    basketStore.removeReward(undefined, rewardcode).then(() => {
      state.applyingRewards = false;
      state.submittingPromo = false;
    }).catch((error: Error) => {
      if (error.message && error.message == "timeNeedsAdjusted") { 
        const currentTimeWanted = DateTime.fromISO(cateringOrderStore.cateringOrder!.time_wanted)
        // The basket already had a time set on it; so we'll have to notify the user
        setNextAvailableTimeFallback(true, currentTimeWanted).then(() => {
          state.applyingRewards = false;
          state.submittingPromo = false;
        });
      } else {
        state.applyingRewards = false;
        state.submittingPromo = false;
        errorFlash("Error", error.message);
      }
    })
  })

  const removeReward = ((reward: RewardInterface) => {
    state.applyingRewards = true;
    basketStore.removeReward(reward).then(() => {
      state.applyingRewards = false;
      state.submittingPromo = false;
    }).catch((error: Error) => {
      if (error.message && error.message == "timeNeedsAdjusted") { 
        const currentTimeWanted = DateTime.fromISO(cateringOrderStore.cateringOrder!.time_wanted)
        // The basket already had a time set on it; so we'll have to notify the user
        setNextAvailableTimeFallback(true, currentTimeWanted).then(() => {
          state.applyingRewards = false;
          state.submittingPromo = false;
        });
      } else {
        state.applyingRewards = false;
        state.submittingPromo = false;
        errorFlash("Error", error.message);
      }
    })
  })

  const closeRewardsDiscountModal = (() => {
    state.showRewardsDiscountModal = false;
    state.showPromoDiscountModal = false;
  })

  const applyRewardsWarningPromptTitle = computed(() => {
    let text = "Multiple Discounts";

    // We don't actually support fundraisers in the catering app just yet
    // if (basketStore.appliedFundraiser != null)  {
      // text = "Remove Fundraiser?"
    // }

    return text;
  })
  
  const applyRewardsWarningPromptText = computed(() => {
    let text = "Applying this reward will remove any other discounts you have applied. Are you sure you want to continue?";

    // We don't actually support fundraisers in the catering app just yet
    // if (basketStore.appliedFundraiser != null)  {
      // text = "Applying rewards to this order will remove the '\(basketStore.appliedFundraiser)' fundraiser. Do you wish to continue?."
    // }

    return text;
  })

  const rewardsButtonClick = (() => {
    state.showRewardsModal = true;
  })

  const closeRewardsModal = (() => {
     state.showRewardsModal = false;
  })

  const savedCreditCards = computed(() => {
    if (state.billingAccounts) {
      return state.billingAccounts.filter((acct) => {
        return acct.accounttype == 'creditcard'
      })
    } else {
      return [];
    }
  })

  const savedGiftCards = computed(() => {
    if (state.billingAccounts) {
      return state.billingAccounts.filter((acct) => {
        return acct.accounttype.toLowerCase().indexOf('gift card') > -1
      })
    } else {
      return [];
    }
  })

  const availableRewardsCount = computed(() => {
    let available = 0;

    if (state.rewards && state.rewards.length > 0) {
      available += state.rewards.length
    }

    return available;
  })

  const rewardsButtonText = computed(() => {
    let buttonText = ""
    if (basketStore.basket) {
      const manualRewards = basketStore.basket!.manuallyAppliedRewards();
      let rewardsCount = 0

      if (availableRewardsCount.value > 0 && state.rewards) {
        rewardsCount = availableRewardsCount.value
      }

      if (availableRewardsCount.value > 0 && state.rewards) {
        buttonText = 'View '+ state.rewards.length + ' ' + app!.appContext.config.globalProperties.pluralizeProductName('Reward', state.rewards.length);
      } else if (state.rewardsLoading){
        buttonText = "Loading Rewards"
      } else {
        buttonText = "No available rewards"
      }
    }

    return buttonText
  })

  const contactInfoIsValid = computed(() => {
    let valid = (state.contactInfo.firstName.length > 0 &&
    state.contactInfo.lastName.length > 0 &&
    state.contactInfo.emailAddress.length > 0 &&
    state.contactInfo.phoneNumber.length > 0 &&
    state.contactInfo.contact.length > 0)

    return valid;
  })

  const setNextAvailableTimeFallback = ((notifyUser: boolean, timewanted: DateTime): Promise<any> => {
    return new Promise((resolve, reject) => {
      basketStore.setNextAvailableTime(timewanted, true).then(() => {
        if (cateringOrderStore.cateringOrder && cateringOrderStore.cateringOrder!.time_wanted) {
          let dt = DateTime.fromISO(cateringOrderStore.cateringOrder!.time_wanted);
          cateringOrderStore.preAdjustmentTime = dt;
        }
        resolve('');
      }).catch((error: any) => {
        if (error.message && error.message == "timeNeedsAdjusted" && basketStore.basket) { 
          const currentTimeWanted = DateTime.fromFormat(basketStore.basket!.timewanted, 'yyyyMMdd hh:mm');
          // The basket already had a time set on it; so we'll have to notify the user
          setNextAvailableTimeFallback(true, currentTimeWanted).then(() => {
            // 
          });
        } else {
          errorFlash('Error', error.message);
        }
      })
    }); 
  })

  const errorFlash = (title: string, text: string) => {
    const message = {
      id: Math.round(Date.now() / 1000),
      messageType: "danger",
      text: text,
      headline: title,
      delay: 0, // ms
      icon: "",
      cssClass: "",
    } as FlashMessage;
    flashMessageStore.addMessage(message);
  }

  const pickTimeAdjustment = (() => {
    cateringOrderStore.preAdjustmentTime = null;
    router.push({ name: 'wizard-step', params: { step: 4}})
  })

  const closeTimeAdjustment = (() => {
    cateringOrderStore.preAdjustmentTime = null;
  })

  const deliveryInfoSubmit = ((): Promise<any> => {
    state.deliveryInfo.submitting = true;

    return new Promise((resolve, reject) => {
      basketStore.applyDelivery(state.deliveryInfo.streetaddress, state.deliveryInfo.city, state.deliveryInfo.building, state.deliveryInfo.zipcode, state.deliveryInfo.specialinstructions).then(() => {
        state.deliveryInfo.submitting = false;
        const message = {
          id: Math.round(Date.now() / 1000),
          messageType: "success",
          text: "Your delivery information has been set.",
          headline: "Delivery Information",
          delay: 5000, // ms
          icon: "",
          cssClass: "",
        } as FlashMessage;
        flashMessageStore.addMessage(message);
        state.deliveryInfo.dirty = false;
        resolve('');
      }).catch((error: Error) => {
        state.deliveryInfo.submitting = false;
        if (error.message && (error.message.indexOf('the server responded with status') > -1) || error.message.indexOf('Request failed with status code') > -1) {
          // Unhelpful error
          errorFlash('Delivery Address Error', 'Your delivery address could not be set. Please confirm the address is correct and all required fields have been filled.');
        } else {
          errorFlash('Error', error.message);
        }
        
        reject(error);
      })
    });
  })

  const submitOrderClicked = (() => {
    state.submittingOrder = true;

    if (userStore.userLocation != null && userStore.userLocation.catering_disabled) {
      state.cateringDisabledModalOpen = true;
      state.cateringDisabledMessage = userStore.userLocation.catering_disabled_message;
      state.cateringDisabledModalLocation = userStore.userLocation;
      state.submittingOrder = false;
      return;
    }

    if (userStore.user == null) {
      if (!contactInfoIsValid.value) {
        errorFlash('Contact Information', 'Please set the required contact information for your order.');
        state.submittingOrder = false;
        return;
      }
    }

    if (cateringOrderStore.cateringOrder!.delivery_mode == 'delivery') {
      if (state.deliveryInfo.dirty) {
        errorFlash('Delivery Address Changes', ('Please submit your delivery address changes prior to checking out.'))
        state.submittingOrder = false;
      } else if (state.contactInfo.contact && cateringOrderStore.cateringOrder && state.contactInfo.contact != cateringOrderStore.cateringOrder?.contact_name) {
        // We must submit the contact info first
        let cateringOrder = cateringOrderStore.cateringOrder;
        cateringOrder!.contact_name = state.contactInfo.contact;

        cateringOrderStore.updateCateringOrder(cateringOrder!.id, cateringOrder).then(() => {
          submitOrder();
        }).catch((error: Error) => {
           errorFlash('Error', ('Order could not be placed.' + error.message))
           state.submittingOrder = false;
        });
      } else if (basketStore.basket && (basketStore.basket!.deliveryaddress == null || basketStore.basket!.deliveryaddress.id == null)) {
        errorFlash('Delivery Address Required', 'Please set delivery information for your order.');
        state.submittingOrder = false;
      } else {
        submitOrder();
      }
    } else {
      if (state.contactInfo.contact && cateringOrderStore.cateringOrder && state.contactInfo.contact != cateringOrderStore.cateringOrder?.contact_name) {
        // We must submit the contact info first
        let cateringOrder = cateringOrderStore.cateringOrder;
        cateringOrder!.contact_name = state.contactInfo.contact;

        cateringOrderStore.updateCateringOrder(cateringOrder!.id, cateringOrder).then(() => {
          submitOrder();
        }).catch((error: Error) => {
           errorFlash('Error', ('Order could not be placed.' + error.message))
           state.submittingOrder = false;
        });
      } else {
        submitOrder();
      }
    }
  })

  const submitOrder = (() => {
    if (!state.selectedPayment) {
      errorFlash('Payment Error', 'Please select a payment option.')
      state.submittingOrder = false;
    } else {
      const payments = [] as BasketBillingMethod[];
      payments.push(state.selectedPayment!);

      // TODO: If we move to supporting split payments this needs updated to set values dynamically
      payments[0].amount = basketStore.basket!.total;
      if (basketStore.basket!.tip) {
        payments[0].tipportion = basketStore.basket!.tip;
      } else {
        payments[0].tipportion = 0;
      }

      const order = plainToClass(Order, {
        billingaccounts: payments
      }, { excludeExtraneousValues: true });

      if (userStore.user) {
        order.usertype = "user"
        let user = userStore.user;
        order.firstname = user.first_name;
        order.lastname = user.last_name;
        order.emailaddress = user.email;
        order.contactnumber = user.cellNumber;
      } else {
        order.usertype = "guest"
        order.firstname = state.contactInfo.firstName;
        order.lastname = state.contactInfo.lastName;
        order.emailaddress = state.contactInfo.emailAddress;
        order.contactnumber = state.contactInfo.phoneNumber;
      }

      basketStore.submitOrder(order).then(function(resp: OrderDetailsClass) {
        state.submittingOrder = false;
        event('purchase', {
          "transaction_id": resp.oloid,
          "value": resp.total,
          "currency": "USD",
          "tax": resp.taxes[0].tax,
          "items": resp.products.map((prod) => { 
            return {
              "item_id": prod.id,
              "item_name": prod.name,
              "price": prod.totalcost / prod.quantity,
              "quantity": prod.quantity,
            }
          }),
          "ordering_platform": "Vue"
        })
        router.push('order-confirmation');
      }).catch((error: Error) => {
        errorFlash('Error', ('Order could not be placed. ' + error.message))
        state.submittingOrder = false;
      })
    }
  })

  const showEditingOrderAlert = computed(() => {
    return basketStore.editing
  })

  const editCutoffTime = computed(() => {
    return basketStore.editOrderCutoffTime
  })
  
  const closeCateringDisabledModal = () => {
    state.cateringDisabledModalOpen = false;
    window.setTimeout(function() {
      state.cateringDisabledMessage = undefined;
      state.cateringDisabledModalLocation = undefined;
    }, 500);
  }

  const redirectWizard = () => {
    closeCateringDisabledModal();
    router.push('/wizard')
  }

  const cancelEditOrder = () => {
    basketStore.cancelEditOrder().then(() => {
      router.push('wizard');
    })
  }
</script>